import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import { useState } from 'react';
import ImageModal from './ImageModal';

interface ImgItem {
  imgNo: string;
  src: string;
  description?: string;
}

interface Props {
  imgList: ImgItem[];
  iidx: number;
}

const ImgSlider = ({ imgList, iidx }: Props) => {
  const [currentpage, setCurrentPage] = useState(1);
  const [showImageModal, setShowImageModal] = useState(false);

  const setting = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (current: number) => setCurrentPage(current + 1),
  };

  return (
    <Container>
      <ImgBox>
        <Slider {...setting}>
          {imgList.map((img) => (
            <div key={img.imgNo}>
              <img
                src={`${process.env.REACT_APP_HOST_API}img/${img.src}`}
                alt={img.description || 'Image'}
                style={{
                  width: '100%',
                  height: '240px',
                  contain: 'cover',
                  // objectFit: 'cover',
                }}
              />
            </div>
          ))}
        </Slider>
      </ImgBox>
      <PageNumber>
        <span style={{ color: 'white' }}>
          {currentpage} /{imgList.length}
        </span>
        <Divider />
        <span onClick={() => setShowImageModal(true)}>모든 사진보기</span>
      </PageNumber>
      <SaveImgButton
        onClick={() => window.open(`/save-images?iidx=${iidx}`, '_blank')}
      >
        <img src="/assets/images/icon/save-white.svg" alt="" />
        <span>사진저장</span>
      </SaveImgButton>
      {showImageModal && (
        <ImageModal
          isClose={() => setShowImageModal(false)}
          imgList={imgList}
        />
      )}
      <style>
        {`
    .slick-prev, .slick-next {
      z-index: 10;
      width: 40px;
      height: 40px;
    }
    .slick-prev {
      left: 6px;
    }
    .slick-next {
      right: 6px;
    }
  `}
      </style>
    </Container>
  );
};

export default ImgSlider;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const ImgBox = styled.div`
  width: 100%;
  height: 240px;
`;

const PageNumber = styled.div`
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.78);

  color: #e4e4e4;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const Divider = styled.div`
  width: 1px;
  height: 10px;
  background-color: #fff;
`;

const SaveImgButton = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  border-radius: 9999px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #000000c7;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  text-align: center;
  color: #e4e4e4;
`;
